import React, { FC, memo } from 'react'
import styled from 'styled-components'
import { Heading } from '@ucheba/ui/components/Heading/desktop'
import { Grid } from '@ucheba/ui/components/Grid/desktop'
import { Tooltip } from '@ucheba/ui/components/Tooltip/desktop'
import { Text } from '@ucheba/ui/components/Text/desktop'
import { sm } from '@ucheba/utils/helpers/styles/mixins'
import { Picture } from '@ucheba/ui/components/Picture'
import { IAboutCompaniesProps } from '../types'

const Block = styled.div``

const Logo = styled(Picture)`
  height: 56px;
`

const List = styled.div`
  width: 100%;
  display: flex;
  gap: 48px;
  flex-wrap: wrap;

  ${sm.breakpoint.smAndDown`
    flex-wrap: nowrap;
    overflow-x: scroll;
    padding-bottom: 16px;
  `};
`

/** Где работают */
const AboutCompanies: FC<IAboutCompaniesProps> = (props) => {
  const { title, items } = props

  return (
    <Block>
      <Heading h3={title} spacing='large' />

      <Grid spacing='xxlarge'>
        <List>
          {items.map((item) => {
            const { id, logo, name } = item

            if (logo?.fallbackUrl || logo?.webp) {
              return (
                <Tooltip
                  key={id}
                  content={<Text color='black'>{name}</Text>}
                  position='right-center'
                  width='200px'
                >
                  <Logo
                    alt='логотип компании'
                    webpUrl={logo?.webp}
                    fallbackUrl={logo?.fallbackUrl}
                  />
                </Tooltip>
              )
            }

            return null
          })}
        </List>
      </Grid>
    </Block>
  )
}

export default memo(AboutCompanies)
